<template>
  <div class="ccui-home-index">
    <div class="ccui-app-container">
      <!--高级搜索Begin-->
      <el-search
        :formProp="formData"
        @search="search"
        @change="change"
        :isShowSearch="true"
        :selectClear="true"
        class="ccui-highsearch no-print"
        :class="[
          languagezh_cn ? '' : 'languageen_us',
          'ccui-highsearch no-print'
        ]"
      >
        <anchorTitle
          isList
          :tabBtn="tableTopBtn"
          :isFocus="isFocus"
          :isShowNum="true"
          :totalNum="pageTotal"
          @tabBtnChange="tableTopChange"
        />
        <template slot="search">
          <!-- 标题 -->
          <el-input
            v-model.trim="formData.noticeTitle"
            clearable
            :searchLabel="$t('page.content.noticeTitle')"
            :placeholder="$t('page.content.noticeTitlePlaceholder')"
          ></el-input>
          <el-date-picker
            v-model.trim="formData.protocolTime"
            :searchLabel="$t('page.content.Publish')"
            clearable
            type="daterange"
            :range-separator="$t('page.content.to')"
            :start-placeholder="$t('page.content.pleaseChoose')"
            :end-placeholder="$t('page.content.pleaseChoose')"
          ></el-date-picker>
        </template>
        <!-- 标题 -->
        <el-input
          v-model.trim="formData.noticeTitle"
          clearable
          :searchLabel="$t('page.content.noticeTitle')"
          :placeholder="$t('page.content.noticeTitlePlaceholder')"
          slot="searchItem2"
        ></el-input>
        <el-date-picker
          v-model.trim="formData.protocolTime"
          :searchLabel="$t('page.content.Publish')"
          clearable
          type="daterange"
          :range-separator="$t('page.content.to')"
          :start-placeholder="$t('page.content.pleaseChoose')"
          :end-placeholder="$t('page.content.pleaseChoose')"
          slot="searchItem4"
        ></el-date-picker>
      </el-search>
      <!--高级搜索End-->
      <!--table表格区域Begin-->
      <div class="ccui-multifunctional-table-wrapper">
        <listBaseTable
          :tableName="tableName"
          :showCheckBox="false"
          :showOp="false"
          :showOpObj="showOpObj"
          :data="tableData"
          :cellStyle="cellStyle"
          :pageNo.sync="pageNo"
          :pageSize.sync="pageSize"
          :pageTotal="pageTotal"
          :fixedTableThead="fixedTableThead"
          :unfixedTableThead="unfixedTableThead"
          border
          @handleRowClick="handleRowClick"
          @changeTableTitleWidth="changeTableTitleWidth"
          @handleList="handleList"
          @select-all="handleCheckAllChange"
          @select="handleCheckChange"
          @selection-change="handleSelectionChange"
          :emptyText="emptyText"
        >
          <!--列表中的插槽Begin-->
          <template slot="noticeTitle" slot-scope="{ row }">
            <el-button
              size="mini"
              class="taskCodeBtn"
              type="text"
              @click="handleOp(row)"
              >{{ row.noticeTitle }}</el-button
            >
          </template>
          <template slot="noticeStartTime" slot-scope="{ row }">
            <span>
              {{ row.noticeStartTime | formatTime1 }}
            </span>
          </template>
          <!--列表中的插槽End-->
          <!--批量操作-->
        </listBaseTable>
      </div>
      <!--table表格区域End-->
    </div>
  </div>
</template>

<script>
import {
  listSupBidNoticeOfPurchase,
  getSupInfoByLoginInfo
} from "@/app/myProjects/api/myProjects.js";
import { getSupInfoByLoginInfoSub } from "@/app/myProjects/api/myProjectsEl.js";
import moment from "moment";
import { commonTableWidth } from "@/setting/setting.js";
import Cookies from "js-cookie";
export default {
  name: "noticeOfWinningBid",
  components: {},
  // created() {
  //   this.getSupplierList(); // 必须在created里面
  // },
  computed: {
    languagezh_cn() {
      return (Cookies.get("language") || "zh-cn") === "zh-cn";
    }
  },
  data() {
    return {
      tableName: "noticeOfWinningBid", // 默认的tableName 工程中唯一
      isSelection: false,
      showOpObj: {
        showOpSetting: false, // 是否高级设置
        width: 0 // 操作宽度
      },
      formData: {
        noticeTitle: "",
        noticeTimeStart: "",
        noticeTimeEnd: "",
        protocolTime: []
      },
      tableTopBtn: [
        { label: this.$t("page.menuList.notificationAwardResults"), value: "1" }
      ], //全部
      isFocus: "1",
      tableData: [],
      fixedTableThead: [
        {
          label: this.$t("page.content.No"), //序号
          type: "index",
          width: commonTableWidth.serialNoWidth,
          fixed: true
        },
        {
          label: this.$t("page.content.noticeTitle"), //公告标题
          prop: "noticeTitle",
          slot: "noticeTitle",
          minWidth: 200,
          fixed: true
        }
      ],
      unfixedTableThead: [
        {
          label: this.$t("page.content.zhongbiaojieguo"), //中标/未中标
          prop: "bidFlag",
          minWidth: 120
        },
        {
          label: this.$t("page.content.ProjectNo"), //项目编号
          prop: "schemeCode",
          minWidth: 200
        },
        {
          label: this.$t("page.content.ProjectName"), //项目名称
          prop: "schemeName",
          minWidth: 200
        },
        // {
        //   label: this.$t("page.content.Supplier"), //供应商名称
        //   prop: "supName",
        //   width: commonTableWidth.supplierName
        // },
        {
          label: this.$t("page.content.Publish"), //公告发布时间
          prop: "noticeStartTime",
          width: commonTableWidth.dateTime2Width,
          slot: "noticeStartTime"
        }
      ],
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      supInfo: {}, //物采供应商信息
      // subcontractorInfo: {}, //分包商信息
      emptyText: "",
      subcontractorCode: "" //分包商账号
    };
  },

  methods: {
    tableTopChange({ value }) {
      // 按钮切换
      // 初始化
      this.isFocus = value;
    },
    // initSearchData() {
    //   this.formData = {
    //     supplierCode: "",
    //     supplierName: "",
    //     supplierShortName: ""
    //   };
    //   this.pageNo = 1;
    //   this.pageSize = 10;
    //   this.getSupplierList();
    // },
    handleList() {
      // 分页操作列表
      this.getSupplierList();
    },
    getSupCode() {
      let loginId = JSON.parse(localStorage.getItem("userInfo")).loginId;
      getSupInfoByLoginInfo({
        loginId: loginId,
        agentId: this.$router.history.current.query.a
      }).then(res => {
        if (res) {
          if (
            res.data.data.supCode !== "" &&
            res.data.data.supCode !== null &&
            res.data.data.supCode !== "0"
          ) {
            this.supInfo = res.data.data;
            sessionStorage.setItem("supCode", res.data.data.supCode);
            sessionStorage.setItem("supInfo", JSON.stringify(res.data.data));
            this.getSupInfoByLoginInfoSubBox(1);
          } else {
            this.getSupInfoByLoginInfoSubBox(2);
          }
        }
      });
    },
    getSupInfoByLoginInfoSubBox(type) {
      let loginId = JSON.parse(localStorage.getItem("userInfo")).loginId;
      getSupInfoByLoginInfoSub({
        loginId: loginId,
        agentId: this.$router.history.current.query.a
      }).then(res => {
        if (res) {
          this.subcontractorInfo = res.data.data;
          sessionStorage.setItem("subcontractorCode", res.data.data.supCode);
          sessionStorage.setItem(
            "subcontractorInfo",
            JSON.stringify(res.data.data)
          );
          // if (type == 2) {
          //   this.supInfo = res.data.data;
          //   sessionStorage.setItem("supCode", res.data.data.supCode);
          //   sessionStorage.setItem("supInfo", JSON.stringify(res.data.data));
          // }
          this.getSupplierList();
        }
      });
    },
    getSupplierList() {
      if (this.subcontractorInfo && this.supInfo) {
        let supCodeList = [];
        let subcontractorCodeList = [];
        if (this.supInfo.getSupInfoByLoginInfoRspBOList) {
          supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(
            item => {
              return item.supCode;
            }
          );
        }
        if (this.subcontractorInfo.getSupInfoByLoginInfoRspBOList) {
          subcontractorCodeList = this.subcontractorInfo.getSupInfoByLoginInfoRspBOList.map(
            item => {
              return item.supCode;
            }
          );
        }
        let param = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          noticeType: "4",
          supCodeList: supCodeList,
          supCode: this.supInfo.supCode,
          qrySupBidNoticeListReqBO: {
            noticeType: "4",
            supCodeList:
              this.supInfo &&
              this.supInfo.supCode + "" == "" &&
              this.subcontractorInfo.getSupInfoByLoginInfoRspBOList.length > 1
                ? [this.subcontractorCode]
                : subcontractorCodeList,
            supCode: this.subcontractorCode
          }
        };
        if (this.formData.protocolTime && this.formData.protocolTime[0]) {
          this.formData.noticeTimeStart = moment(
            this.formData.protocolTime[0]
          ).format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.formData.noticeTimeStart = "";
        }
        if (this.formData.protocolTime && this.formData.protocolTime[1]) {
          this.formData.noticeTimeEnd =
            moment(this.formData.protocolTime[1]).format("YYYY-MM-DD") +
            " 23:59:59";
        } else {
          this.formData.noticeTimeEnd = "";
        }

        //排序问题后端让参数为空的也带上
        let initData = {
          noticeTitle: "",
          noticeTimeStart: "",
          noticeTimeEnd: "",
          protocolTime: []
        };
        Object.assign(
          param,
          { agentId: this.$router.history.current.query.a },
          initData,
          this.formData
        );

        param.isShowLoading = true;
        listSupBidNoticeOfPurchase(param).then(res => {
          this.emptyText = this.$t("page.content.noData");
          if (res) {
            this.tableData = res.data.data.rows;
            this.tableData.forEach(
              e =>
                (e.bidFlag =
                  e?.bidFlag == 1 ? "中标" : e?.bidFlag == 0 ? "未中标" : "")
            );
            this.pageTotal = res.data.data.recordsTotal;
          }
        });
      }
    },
    search(searchData) {
      this.pageNo = 1;
      this.formData = searchData;
      this.getSupplierList();
    },
    handleOp(row, index) {
      this.$store.commit(
        "editRouterName",
        this.$t("page.menuList.notificationAwardResults")
      );
      this.$router.push({
        name: "noticeOfWinningBidDetail1",
        query: {
          schemeId: row.schemeId,
          noticeId: row.noticeId,
          opUnitName: row.opUnitName,
          opUnitId: row.opUnitId,
          purchaseType: row.purchaseType,
          noticeEndTime: row.noticeEndTime,
          noticeStartTime: row.noticeStartTime,
          supCode: row.supCode,
          schemeName: row.schemeName,
          schemeCode: row.schemeCode,
          schemeClass: row.supplierFlag
        }
      });
    },
    change(index, key, value) {
      const formDataKeys = Object.keys(this.formData);
      formDataKeys.map(_ => {
        if (_ !== key) this.formData[_] = "";
      });
    },
    changeTableTitleWidth() {
      // 改变头部宽度
    },
    handleRowClick(row, column, event) {
      // 行点击事件
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    },
    handleCheckAllChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleCheckChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleSelectionChange(arr) {
      this.isSelection = arr.length !== 0;
    }
  },

  mounted() {
    this.supInfo = JSON.parse(sessionStorage.getItem("supInfo"));
    this.subcontractorCode = sessionStorage.getItem("subcontractorCode");
    this.subcontractorInfo =
      JSON.parse(sessionStorage.getItem("subcontractorInfo")) ||
      this.$store.state.app.subcontractorInfo;

    // this.getSupCode();
    this.getSupplierList();
  }
};
</script>

<style lang="scss" scoped>
/deep/ .languageen_us {
  .el-searchs-bottom {
    border-top: none;
    .el-searchs-bottom-form {
      .el-form-item__label {
        min-width: 165px !important;
      }
      .el-input__inner {
        padding-right: 10px;
        // width: 305px;
      }
      .el-form-item__content {
        .el-select {
          // width: 305px;
        }
      }
    }
  }
}
.taskCodeBtn {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  span {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }
}
</style>
